<template>
  <div class="">
    <small :class="clSub('date')"
      >{{ message.trigger_user.name }},
      {{ dateOutput(message.created_at) }}</small
    >
    <div :class="clContainer()">
      <ul class="job-message-list">
        <li class="col-12 col-md-3 pl-0">
          <div v-if="message.context_info.fitting" class="mt-xs mb-xs">
            <job-fitting
              class="font-weight-bold pl-0"
              :fitting="message.context_info.fitting"
            ></job-fitting>
          </div>
          <div v-else-if="message.data.rating">
            <job-rating-display
              :rating="message.data.rating"
              :icon-src="icon"
            ></job-rating-display>
          </div>
          <span
            v-else-if="message.context_info.part"
            class="font-weight-bold pl-0"
          >
            {{ message.context_info.part.name }}
            <div v-if="message.data.check_title">
              {{ message.data.check_title }}
            </div>
          </span>
          <p v-else-if="message.data.reason">
            <span>{{
              __("jobs.components.messages.common.labels.reason")
            }}</span>
            {{ message.data.reason.reason }}
          </p>
          <div v-else-if="message.context_info.requests">
            <span class="font-weight-bold pl-0">
              {{
                __("jobs.components.messages.common.labels.requests", {
                  name: message.trigger_user.name,
                })
              }}
            </span>
            <div class="mt-xxs">
              <job-list-date-item
                v-for="request in message.context_info.requests"
                :date="request.date"
                :key="request.date.id"
                class="d-inline-block mr-xs"
              >
              </job-list-date-item>
            </div>
          </div>
        </li>
        <li class="col-12 col-md-8">
          <div :class="clSub('data')">
            <div :class="clSub('title')">
              <h2>
                {{ __(`messages.jobs.common.${message.sourceTypeName}.title`) }}
              </h2>

              <!-- <small :class="clSub('date')"
            >{{ message.trigger_user.name }},
            {{ dateOutput(message.created_at) }}</small
          > -->
            </div>
            <template v-if="message.data.text">
              <div
                v-tif="
                  `messages.jobs.common.${message.sourceTypeName}.text_label`
                "
              ></div>
              <div :class="clSub('text')" v-html="message.data.text"></div>
            </template>
            <div v-if="message.data.pictures" :class="clSub('pictures')">
              <ul class="list-reset list-h message-img-list">
                <li
                  v-for="(picture, index) in message.data.pictures"
                  :key="index"
                >
                  <button
                    v-if="picture.src"
                    class="btn-plain"
                    @click="showFile(index, $event)"
                  >
                    <img :src="picture.src" />
                  </button>

                  <spinner v-else size="sm" class="align-self-center"></spinner>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Message from "smartdoors-shared/js/components/Messages/Message";
import JobFitting from "smartdoors-shared/js/components/Jobs/JobFitting";
import ShowsJobDateItems from "../../mixins/ShowsJobDateItems";
import { toDate } from "smartdoors-shared/js/helpers/common";
import api from "../../helper/api";
import db from "../../store/persistence/db";

export default {
  extends: Message,
  mixins: [ShowsJobDateItems],
  data() {
    return {
      getLocalfiles: [],
    };
  },
  async beforeCreate() {
    await db.ready;
    const getLocalfiles = await db.getList("files");
    this.getLocalfiles = getLocalfiles;
  },
  components: {
    "job-fitting": JobFitting,
  },
  watch: {
    message: {
      immediate: true,
      handler: function (message) {
        this.message = message;
        if (message.data && "pictures" in message.data) {
          for (const picture of message.data.pictures) {
            if (!("src" in picture) || !picture.src) {
              Vue.set(picture, "src", null);
              setTimeout(
                function () {
                  const filesDb = this.urlById(picture.route);
                  
                  if (filesDb && filesDb != undefined && filesDb.value) {
                    Vue.set(picture, "src", URL.createObjectURL(filesDb.value));
                  } else {
                    const pictureDownloadApiPath =
                      this.config.api.urls.files.download + "/" + picture.route;

                    ((pic) => {
                      api.download(pictureDownloadApiPath).then((url) => {
                        Vue.set(pic, "src", url);
                      });
                    })(picture);
                  }
                }.bind(this),
                1000
              );
            }
          }
        }
      },
    },
  },
  methods: {
    urlById(id) {
      let res = this.getLocalfiles.find((x) => {
        if (x.id == id) {
          return true;
        }
      });
      return res;
    },
    dateOutput(dateString) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const date = toDate(dateString);

      return (
        date.toLocaleDateString(undefined, options) +
        " (" +
        date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
        }) +
        ")"
      );
    },
  },
};
</script>